import { getFontFullPath } from '@/Pages/Clip/SideBar/FontSelector/constants';
import { CaptionLineConfig, CaptionStyles } from '@/domains/asset';
import { TransitionInEffect } from '@/App/remotion/libs/transitions/types';

const simpleBold: Partial<CaptionStyles> = {
  theme_preset: 'simpleBold',
  pageStyle: {
    color: '#ffffff',
    textShadow: '7px 10px 18px #000000'
  },
  wordStyle: undefined,
  letterStyle: undefined,
  font_location: getFontFullPath('Coda-ExtraBold.ttf'),
  caps: true,
  line_config: CaptionLineConfig.TwoLines,
  font_size: 72,
  transitions: {
    pageIn: TransitionInEffect.SlideUp
  }
};

export default simpleBold;
